import { Route } from '@angular/router';

const route: Route = {
  path: 'error',
  loadComponent: () =>
    import('./errors.component').then((m) => m.ErrorsComponent),
  children: [
    {
      path: '404',
      loadComponent: () =>
        import('./error404/error404.component').then((m) => m.Error404Component),
    },
    {
      path: '500',
      loadComponent: () =>
        import('./error500/error500.component').then((m) => m.Error500Component),
    },
    {
      path: '',
      redirectTo: '404',
      pathMatch: 'full',
    },
    {
      path: '**',
      redirectTo: '404',
      pathMatch: 'full',
    },
  ],
};

export default route;
